
<template>
    <van-popup v-model="dataTipShow" round position="bottom" closeable>
         <div class="container">
         <div class="title"> {{ $t('选择区号') }} </div>
         <van-search class="search-bar" v-model="value" shape="round" :placeholder="this.$t('请输入国家/地区/区号')" />
         <div class="scrollable-content">
         <div v-for="(item, index) in regionList" :ref="item.B" :class="['item-container',region === item.B ? 'item-container-select-color' :''] " :key="index" @click="clickItem(item)">
            <div :class="region === item.B ? 'item-text-selected' : 'item-text'" > {{ item.N }}  </div>
            <div :class="region === item.B ? 'item-text-region-selected' : 'item-text-region'" >  {{ item.C }} </div>
            <img v-show="region === item.B" class="check-img" src="@/icons/list_check.png" />
         </div>
         </div>
         </div>
     </van-popup>
   </template>
<script>

import { mapGetters } from 'vuex'

export default {
  name: 'MobilePrefixPopupView',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    region: {
      type: String,
      default: 'MY'
    }
  },

  computed: {
    ...mapGetters(['mobilePrefixList']),
    regionList() {
      if (this.value.length > 0) {
        return this.mobilePrefixList.filter(item => item.N.toLowerCase().includes(this.value.toLowerCase()) || item.C.toLowerCase().includes(this.value.toLowerCase()))
      } else {
        return this.mobilePrefixList
      }
    }
  },
  data() {
    return {
      dataTipShow: this.show,
      value: ''
    }
  },
  watch: {
    show: function(newValue, oldValue) {
      this.dataTipShow = newValue
      if (newValue) {
        this.value = ''
        this.$nextTick(() => {
          this.$refs[this.region][0].scrollIntoView()
        })
      }
    },
    dataTipShow: function(newValue, oldValue) {
      this.$emit('change', newValue)
    }
  },
  methods: {
    clickItem(item){
      this.$emit('onRegionClick', item)
      this.dataTipShow = false
    },
    mobilePrefix(item){
      return item.N
    },
    regionName(item){
      return item.C
    }

  }
}
</script>
   <style lang="less" scoped>
   .container {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background-color: white;
        .title {
            font-size: 16px;
            font-weight: 500;
            color: #2C2C2C;
            height: 55px;
            line-height: 55px;
        }
        .search-bar{
            width: 100%;
            height: 50px;
        }
        .search-bar /deep/ .van-field {
          align-items: center;
        }
        .search-bar /deep/ .van-field__control {
          font-size: 14px;
          height: 30px;
        }
        .scrollable-content{
            overflow-y: auto;
            height: 60vh;
            width: 100%;
        }
        .item-container {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding: 0px 28px;
            height: 64px;
            .item-text {
                font-size: 14px;
                font-weight: 500;
                color: #2C2C2C;
                width:80px;
            }
            .item-text-selected {
                font-size: 14px;
                font-weight: 500;
                color: #00BBBF;
                width:80px;
            }
            .item-text-region {
                font-size: 14px;
                font-weight: 500;
                color: #2C2C2C;
                flex: 1;
            }
            .item-text-region-selected {
                font-size: 14px;
                font-weight: 500;
                color: #00BBBF;
                flex: 1;
            }
            .check-img {
                width: 24px;
                height: 24px;
            }
        }
        .item-container-select-color {
            background-color: rgba(0, 187, 191, 0.1);
        }
   }
   </style>
